import { OrderModel, OrderStatusEnum, RightStoreProductTypeEnum } from './../../../../../../models/rightstore/rightstore.models';
import { autoinject, transient } from "aurelia-dependency-injection";
import { IOrderMetaPlugin } from "../../../../../../models/rightstore/rightstore.models";
import { RightStoreService } from "../../../../../../services/rightstore/rightstore.service";
import { computedFrom } from "aurelia-binding";
import { ConfigService } from '@rightship-tech/common-ui/services/basic/config.service';
import { useView } from 'aurelia-framework';

@autoinject
@transient()
@useView('views/pages/modules/orders/plugins/processing/processing.html')
export class Processing implements IOrderMetaPlugin {

    public disableSubmit: boolean = true;
    public canSubmit: boolean = false;
    public orderGuid: string;
    public order: OrderModel;
    public viewTitle: string = "Processing";
    public orderState: "processing" | "processed" | "failed" = "processing";

    @computedFrom("orderModel.order.product.productTypeId")
    get isPdfReport(): boolean {
        return this.order.product.productTypeId == RightStoreProductTypeEnum.PlatformPdf || this.order.product.productTypeId == RightStoreProductTypeEnum.CompanyReportPdf;
    }

    constructor(private rightStoreService: RightStoreService, private configService: ConfigService) {

    }

    public isValid(): Promise<boolean> {
        return new Promise<boolean>((resolve) => { resolve(true); });
    }

    public getMetaModel() {
        return null
    }

    async activate(args: { order: OrderModel }) {
        this.order = args.order;
        this.orderGuid = this.order.orderGuid;

        //'&& this.isPdfReport' is there so that only report orders have the state 'processed' state - DEL-14425
        this.orderState = this.order.orderStatusId == OrderStatusEnum.Fulfilled && (this.isPdfReport || this.order.product.productTypeId == RightStoreProductTypeEnum.Topup)
            ? "processed" : args.order.orderStatusId == OrderStatusEnum.Failed
                ? "failed" : "processing";
        this.viewTitle = this.order.product.name;
    }

    returnToOrder() {
        return new Promise<void>((resolve) => {
            this.rightStoreService.resetOrderToPendingMeta(this.orderGuid).then(response => {
                if (response) {
                    location.reload();
                }
                resolve();
            });
        });
    }

    returnToRightStore() {
        window.open(this.configService.config.urls.rightStoreUrl, '_self');
    }
}